import { Injectable } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { Store } from '@ngrx/store';
import { EMPTY, Observable, TimeoutError } from 'rxjs';
import { ERROR_TEXT_401, ERROR_TEXT_403, ERROR_TEXT_404, ERROR_TEXT_408, ERROR_TEXT_500 } from '../app.constants';
import { AppService } from '../services/app.service';
import { InformationMessage } from '../models/information-message.model';
import { ErrorMessage } from '../models/error-message.model';
import { ContentState } from '../store/state/content.state';

@Injectable({
    providedIn: 'root'
})
export class ErrorHandlerUtil {

    public errorMessages: {[key: string]: string};
    private labels: {[key: string]: string};

    constructor(private appService: AppService, private store: Store<ContentState>) {
        this.store.select(state => state.labels).subscribe(labels => this.labels = labels);
        this.errorMessages = {
            401: this.labels['errormessage.401'] || ERROR_TEXT_401,
            403: this.labels['errormessage.403'] || ERROR_TEXT_403,
            404: this.labels['errormessage.404'] || ERROR_TEXT_404,
            408: this.labels['errormessage.408'] || ERROR_TEXT_408,
            500: this.labels['errormessage.500'] || ERROR_TEXT_500
        };
    }

    handleError(error: HttpErrorResponse | TimeoutError, customMessage?: string): Observable<never> {
        if (error instanceof TimeoutError || error.status === 408) {
            this.appService.notification.next(new ErrorMessage(this.errorMessages['408']));
        } else if (error.status === 400 && customMessage) {
            this.appService.notification.next(new ErrorMessage(customMessage));
        } else if (error.status === 401) { // session expired
            this.appService.notification.next(new InformationMessage(this.errorMessages['401']));
        } else if (error.status === 403) {
            this.appService.notification.next(new ErrorMessage(this.errorMessages['403']));
        } else if (error.status === 404) { // resource not found
            this.appService.notification.next(new ErrorMessage(this.errorMessages['404']));
        } else { // all other errors
            this.appService.notification.next(new ErrorMessage(this.errorMessages['500']));
        }
        return EMPTY;
    }
}
